export default class RawElement {
  constructor(options) {
    this.learnEditor = options.editor;
    this.savedText = null;
    this.activeElementId = null;
    this.activePosition = null;

    this.init();
  }

  init() {
    const ua = navigator.userAgent,
      action = (ua.match(/iPad/i)) ? "touchstart" : "click";

    $(document).on('click', '.add-build-raw', this.newElement.bind(this));
    $(document).on(action, '.submit-build-raw', this.submitElement.bind(this));
    $(document).on(action, '.cancel-build-raw', this.cancelElement.bind(this));
    $(document).on(action, '.delete-build-raw', this.deleteElement.bind(this));
    $(document).on(action, '.build-raw', this.editElement.bind(this));
  }

  shouldShowButton() {
    return $('input[name$="role"]').val() == "admin" && $('input[name="page_type"]').val() !== 'user';
  }

  addButtonTemplate() {
    return '<a class="add-build-raw" href="#"><i class="fa fa-exclamation-triangle"></i>Raw</a>';
  }

  newElement(event) {
    event.preventDefault();

    let link = $(event.currentTarget);

    //only one editor should be enabled at a time
    if (this.learnEditor.is_editor_enabled()) {
      return;
    }

    this.savedText = null;

    this.insertRaw(link.closest('.button-bar, .bottom-button-bar'));
    this.learnEditor.editing();
  }

  submitElement(event) {
    event.preventDefault();
    const $element = $(event.currentTarget).closest('.build-raw-wrapper');

    const text = $('.build-rawarea').val();

    this.savedText = null;
    this.addRaw($element, text, this.activeElementId, this.activePosition);
    this.activeElementId = "";
    this.activePosition = "";
    this.learnEditor.save_page("Before Added Raw Element");
  }

  editElement(event) {
    event.preventDefault();
    //or if an editor is already present
    if(this.learnEditor.is_editor_enabled()) { //only one editor should be enabled at a time
      return;
    }

    let $element = $(event.currentTarget);

    const text = $element.html();

    //backup the text, save it in case of cancelling
    this.savedText = text;
    this.activeElementId = $element.attr('id');
    this.activePosition = $element.data('position');
    this.insertRaw($element, text);
    this.learnEditor.centerInView($('.build-raw-wrapper'));
    this.learnEditor.editing();
  }

  cancelElement(event) {
    event.preventDefault();

    let $element = $(event.currentTarget);

    //restore with global saved text
    this.addRaw($element.closest('.build-raw-wrapper'),
                  this.savedText,
                  this.activeElementId,
                  this.activePosition);
    this.activeElementId = "";
    this.activePosition = "";

    this.learnEditor.finishEditing();
  }

  deleteElement(event) {
    event.preventDefault();

    let $element = $(event.currentTarget);

    if (!confirm("Confirm deletion of this element.")) {
      return;
    }

    $element.closest('.build-raw-wrapper').remove();

    this.savedText = null;
    this.activeElementId = "";
    this.activePosition = "";

    this.learnEditor.save_page("Before Deleted Raw Element");
  }

  insertRaw($element, text) {
    const buildText = this.buildRaw(text);

    $element.hide();
    let $build_text = $(buildText).hide();
    $element.replaceWith($build_text);
    $('.build-raw-wrapper').show();

    this.learnEditor.centerInView($('.build-raw-wrapper'));
  }

  buildRaw(text = "") {
    text = text.trim();
    text = text.replace(/<scrptplaceholder/gi, '<script').replace(/<\/scrptplaceholder>/gi, '</script>');
    text = text.replace(/<frmplaceholder/gi, '<form').replace(/<\/frmplaceholder>/gi, '</form>');

    let buildText =
      `<div class='row-fluid build-raw-wrapper'>
        <textarea id='editor' class='build-rawarea span12' style='display=block;'>${text}</textarea>
        <div class='editor-buttons'>
          <button class='delete-build-raw delete'>Delete</button>
          <button class='cancel-build-raw cancel'>Cancel</button>
          <button class='submit-build-raw save'>Save</button>
        </div>
      </div>`;

    let $buildText = $(buildText);

    return $buildText;
  }

  addRaw($element, text, id, position) {
    let rawHtml =
      `<div id='${id || ''}' class='element row-fluid raw-element build-raw' data-position='${position}'>
        ${text}
      </div>`;

    rawHtml = rawHtml.replace(/<script/gi, '<scrptplaceholder').replace(/<\/script>/gi, '</scrptplaceholder>');
    rawHtml = rawHtml.replace(/<form/gi, '<frmplaceholder').replace(/<\/form>/gi, '</frmplaceholder>');

    if (text) {
      $element.replaceWith(rawHtml);
    } else {
      $element.remove();
    }
  }
}
